import { Helmet } from "react-helmet-async";

function SEO() {
  // pathname hiện tại
  const pathname = window.location.pathname;

  // remove dấu "/" cuối
  const cleanPath =
    pathname.length > 1 && pathname.endsWith("/")
      ? pathname.slice(0, -1)
      : pathname;

  // canonical full
  const canonicalUrl = `https://biosense.mobile-id.vn${cleanPath}`;

  return (
    <Helmet>
      {/* ROBOTS */}
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="bingbot" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />

      {/* CANONICAL */}
      <link
        rel="canonical"
        href={canonicalUrl}
      />

      {/* HREFLANG */}
      <link
        rel="alternate"
        hrefLang="en"
        href="https://biosense.mobile-id.vn/en"
      />

      <link
        rel="alternate"
        hrefLang="vi"
        href="https://biosense.mobile-id.vn/vi"
      />

      <link
        rel="alternate"
        hrefLang="x-default"
        href="https://biosense.mobile-id.vn/en"
      />

      {/* SCHEMA */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          name: "BioSense",
          applicationCategory: "BusinessApplication",
          operatingSystem: "Web",
          url: canonicalUrl,
          image: "https://biosense.mobile-id.vn/favicon.png",
        })}
      </script>
    </Helmet>
  );
}

export default SEO;